import React, { useState, useEffect } from "react";
import { Cookie } from "lucide-react";

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem("gifted_cookie_consent");
    if (!choice) setShow(true);
  }, []);

  const decide = (value) => {
    localStorage.setItem("gifted_cookie_consent", value);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div data-testid="cookie-consent" className="fixed bottom-5 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-2xl bubble-in">
      <div className="surface rounded-[1.5rem] p-5 flex flex-col sm:flex-row items-center gap-4">
        <div className="w-10 h-10 rounded-full bg-yellow-500/10 flex items-center justify-center shrink-0">
          <Cookie className="w-5 h-5 gold-text" />
        </div>
        <p className="text-sm text-muted-foreground flex-1 text-center sm:text-left">
          We use a few gentle cookies to remember your preferences and improve your concierge experience.
        </p>
        <div className="flex gap-2 shrink-0">
          <button data-testid="cookie-decline" onClick={() => decide("declined")}
            className="text-sm px-4 py-2.5 rounded-2xl surface text-muted-foreground hover:text-foreground">
            Decline
          </button>
          <button data-testid="cookie-accept" onClick={() => decide("accepted")}
            className="text-sm px-5 py-2.5 rounded-2xl bg-gradient-to-r from-primary to-secondary text-white hover:opacity-90">
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
